import { client } from '../client';

interface Payload {
  email: string;
  actor_id?: number;
}

export interface SendResetEmailResponse {
  message: string;
}
export const sendResetEmail = async (payload: Payload): Promise<SendResetEmailResponse> => {
  const { data } = await client.post<SendResetEmailResponse>(`/auth/send_reset_email`, payload);

  return data;
};
